 import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Privacy Policy</h1>

        <p style={styles.text}>
          At FUNPRO GAMES (SMC-PRIVATE) LIMITED, this privacy policy applies to the
          mobile application provided by FUNPRO GAMES (SMC-PRIVATE) LIMITED
          (hereafter referred to as the “Service Provider”) as a Free service and
          this service is provided “AS IS.” The Application does not collect any
          data at all, including no personal data, no sensitive data, and no
          information of any kind from users, and the Service Provider does not
          store, process, or share any user information. Since the Application
          does not collect any data, no information is shared with any third
          parties, there is nothing to opt out of, and you may discontinue using
          the Application at any time by uninstalling it. The Application does
          not collect or retain any data, and if you have concerns, you may
          contact the Service Provider at{" "}
          <a href="mailto:developer@funprogames.com.pk">
            developer@funprogames.com.pk
          </a>
          . The Application does not collect any data from anyone, including
          children, and the Service Provider does not knowingly solicit or store
          any information from children. Although the Application does not
          collect data, the Service Provider is committed to maintaining secure
          and safe application practices. This Privacy Policy may be updated
          occasionally, and any changes will be posted on this page, and
          continued use of the Application will be considered acceptance of the
          updated policy. This privacy policy is effective as of 2026-2-18, and
          by using the Application, you agree to the terms of this Privacy Policy.
          If you have any questions about this Privacy Policy, please contact:
          📧 developer@funprogames.com.pk.
        </p>

        <div style={styles.footer}>
          <strong>FUNPRO GAMES (SMC-PRIVATE) LIMITED</strong>
          <br />
          <span>2/18/2026</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: "100vh",
    backgroundColor: "#ffffff",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    width: "100%",
    textAlign: "center",
  },
  heading: {
    fontSize: "36px",
    fontWeight: "700",
    marginBottom: "30px",
    color: "#111",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#444",
    textAlign: "center",
  },
  footer: {
    marginTop: "40px",
    fontSize: "14px",
    color: "#555",
  },
};

export default PrivacyPolicy;